/* prettier-ignore */
const aeJSON = {
  '(optional)': '(optional)',
  '% of Total': '% of Total',
  'Activities by type': 'Activities by type',
  'Activities completed by member': 'Activities completed by member',
  'Activities completed by professional': 'Activities completed by professional',
  'Activities summary': 'Activities summary',
  'Add a note explaining your decision': 'Add a note explaining your decision',
  'After date': 'After date',
  'Agree & submit': 'Agree & submit',
  'Agreed on decision and moved to closed': 'Agreed on decision and moved to closed',
  'Already have an account?': 'Already have an account?',
  'already reviewed': 'already reviewed',
  'Apply filter': 'Apply filter',
  'Asset Type': 'Asset Type',
  'Average time to resolve a submission marked for action': 'Average time to resolve a submission marked for action',
  'Average time to resolve': 'Average time to resolve',
  'Bad parking': 'Bad parking',
  'Before date': 'Before date',
  'Between dates': 'Between dates',
  'Bulk actions': 'Bulk actions',
  'Cannot move records to Capture stage': 'Cannot move records to Capture stage',
  'Captur Dashboard': 'Captur Dashboard',
  'Capture': 'Capture',
  'Check your email for further instructions': 'Check your email for further instructions',
  'Clear filter': 'Clear filter',
  'Click here': 'Click here',
  'Compared to previous period': 'Compared to previous period',
  'Continue to login': 'Continue to login',
  'Copied!': 'Copied!',
  'Copy to clipboard': 'Copy to clipboard',
  'Count of all records in Action stage. These should be actioned as soon as possible': 'Count of all records in Action stage. These should be actioned as soon as possible',
  'Count of all records in Closed stage. No further action is required': 'Count of all records in Closed stage. No further action is required',
  'Count of all records in Review stage. These should be reviewed and either flagged for Action or moved to Closed': 'Count of all records in Review stage. These should be reviewed and either flagged for Action or moved to Closed',
  'Count of all records': 'Count of all records',
  'Create account': 'Create account',
  'Create record': 'Create record',
  'Dark colour themes': 'Dark colour themes',
  'Dashboards': 'Dashboards',
  'Decision changed and moved to closed': 'Decision changed and moved to closed',
  'Decision changed': 'Decision changed',
  'Decision note is required': 'Decision note is required',
  'Decision note': 'Decision note',
  'Delete this record': 'Delete this record',
  'Drag & drop files here': 'Drag & drop files here',
  'Drop the files to start uploading': 'Drop the files to start uploading',
  'Edit record': 'Edit record',
  'Email is required': 'Email is required',
  'Email': 'Email',
  'Enter the email used for registration to reset your password': 'Enter the email used for registration to reset your password',
  'files uploaded': 'files uploaded',
  'Fill in the fields below to sign into your account': 'Fill in the fields below to sign into your account',
  'Filter records': 'Filter records',
  'Filter search': 'Filter search',
  'Good parking': 'Good parking',
  'I accept the terms and conditions': 'I accept the terms and conditions',
  'Images are being uploaded': 'Images are being uploaded',
  'Improvable parking': 'Improvable parking',
  'Individual productivity': 'Individual productivity',
  'Insufficient information': 'Insufficient information',
  'Label': 'Label',
  'Language Switcher': 'Language Switcher',
  'Last 30 days': 'Last 30 days',
  'Last 7 days': 'Last 7 days',
  'Last 90 days': 'Last 90 days',
  'Light colour themes': 'Light colour themes',
  'Location on map not available': 'Location on map not available',
  'Lost password?': 'Lost password?',
  'Manage the day to day tasks for your workspace': 'Manage the day to day tasks for your workspace',
  'Move to Action': 'Move to Action',
  'Move to Closed': 'Move to Closed',
  'Move to Review': 'Move to Review',
  'Must be at least 10 characters': 'Must be at least 10 characters',
  'New records to review': 'New records to review',
  'No changes applied as records already match stage': 'No changes applied as records already match stage',
  'No image': 'No image',
  'No previous results': 'No previous results',
  'No vehicle in image': 'No vehicle in image',
  'Number is required': 'Number is required',
  'Number of records submitted in current period': 'Number of records submitted in current period',
  'On date': 'On date',
  'on last period': 'on last period', 
  'Password is required': 'Password is required',
  'Password': 'Password',
  'Poor image quality': 'Poor image quality',
  'Poorly parked': 'Poorly parked',
  'Post ride': 'Post ride',
  'Previous period': 'Previous period',
  'Privacy Policy': 'Privacy Policy',
  'Proof of Delivery': 'Proof of Delivery',
  'Record details': 'Record details',
  'Record list': 'Record list',
  'Record productivity summary': 'Record productivity summary' ,
  'Record summary': 'Record summary',
  'Record types': 'Record types',
  'Records - Management': 'Records - Management',
  'Records to review': 'Records to review',
  'Records with at least one tag': 'Records with at least one tag',
  'Recover Password': 'Recover Password',
  'Reset search': 'Reset search',
  'Review records': 'Review records',
  'Reviews and decisions made by team members': 'Reviews and decisions made by team members',
  'Rows per page': 'Rows per page',
  'Search ...': 'Search ...',
  'Search for exact match on number only': 'Search for exact match on number only',
  'Select decisions...': 'Select decisions...',
  'Select labels...': 'Select labels...',
  'Select record type': 'Select record type',
  'Send me a new password link': 'Send me a new password link',
  'Set decision': 'Set decision',
  'Sign in here': 'Sign in here',
  'Sign in': 'Sign in',
  'Sign out': 'Sign out',
  'Sign up here': 'Sign up here',
  'Sign up without a workspace is not supported. Please contact your workspace administrator for signup instructions': 'Sign up without a workspace is not supported. Please contact your workspace administrator for signup instructions',
  'Skip': 'Skip',
  'Start reviewing': 'Start reviewing',
  'Submissions Summary': 'Submissions Summary',
  'Submit change': 'Submit change',
  'Submitted by role': 'Submitted by role',
  'Submitted by': 'Submitted by',
  'Submitted date': 'Submitted date',
  'Tags/Labels': 'Tags/Labels',
  'Team Productivity': 'Team Productivity',
  'Terms of Service': 'Terms of Service',
  'The email provided should be a valid email address': 'The email provided should be a valid email address',
  'The password reset instructions have been sent to your email': 'The password reset instructions have been sent to your email',
  'Theme Settings': 'Theme Settings',
  'Too close up': 'Too close up',
  'Too far away': 'Too far away',
  'Total records submitted': 'Total records submitted',
  'Total submissions': 'Total submissions',
  'View all': 'View all',
  'View help': 'View help',
  'Volume of activity created': 'Volume of activity created',
  'Volume of issue activity created': 'Volume of issue activity created',
  'Volume of submissions and their decision outcomes': 'Volume of submissions and their decision outcomes',
  'Want to try to sign in again?': 'Want to try to sign in again?',
  'Weather conditions': 'Weather conditions',
  'You cannot upload these file types': 'You cannot upload these file types',
  'You have been invited to join Captur.': 'You have been invited to join Captur.',
  'You have provided an invalid email and password combination': 'You have provided an invalid email and password combination',
  'You must agree to our terms and conditions': 'You must agree to our terms and conditions',
  "Don’t have an account yet?": "Don’t have an account yet?",
  Action: 'Action',
  Actions: 'Actions',
  active: 'active',
  Active: 'Active',
  Activities: 'Activities',
  Admin: 'Admin',
  All: 'All',
  Analytics: 'تحليلات',
  Approved: 'Approved',
  Archived: 'Archived',
  Audit: 'Audit',
  Back: 'Back',
  Blocked: 'Blocked',
  Blocking:'Blocking',
  Cancel: 'Cancel',
  Changed: 'Changed',
  Close: 'Close',
  Closed: 'Closed',
  Confirm: 'Confirm',
  Created: 'Created',
  current: 'current',
  Custom: 'Custom',
  Customer: 'Customer',
  Daily: 'Daily',
  dashboard: 'dashboard',
  Data: 'Data',
  days: 'days',
  Decision: 'Decision',
  Decisions: 'Decisions',
  Delete: 'Delete',
  Descriptor: 'Descriptor',
  Details: 'Details',
  Download: 'Download',
  Hello: 'Hello',
  History: 'History',
  Home: 'Home',
  hours: 'hours',
  inactive: 'inactive',
  Inactive: 'Inactive',
  Invited: 'Invited',
  Issues: 'Issues',
  Labels: 'Labels',
  Language: 'Language',
  Location: 'Location',
  Locations: 'Locations',
  Login: 'تسجيل الدخول',
  Map: 'Map',
  Member: 'Member',
  minutes: 'minutes',
  Monthly: 'Monthly',
  New: 'New',
  No: 'No',
  Notes: 'Notes',
  Number: 'Number',
  On: 'On',
  Pending: 'Pending',
  prediction: 'prediction',
  Previous: 'Previous',
  Professional: 'Professional',
  Public: 'Public',
  records: 'records',
  Records: 'Records',
  Reports: 'التقارير',
  review: 'review',
  Save: 'Save',
  Search: 'بحث',
  seconds: 'seconds',
  Settings: 'إعدادات',
  Showing: 'Showing',
  Stage: 'Stage',
  State: 'State',
  Submitted: 'Submitted',
  Subscribed: 'Subscribed',
  Tags: 'Tags',
  Theme: 'Theme',
  Today: 'Today',
  Total: 'Total',
  Type: 'Type',
  Version: 'إصدار',
  Welcome: 'مرحبا',
  Workspace: 'Workspace',
  Yes: 'Yes',
  Zone: 'Zone',
  "Decisions made by Captur's models and customer support across all related workspaces": "Decisions made by Captur's models and customer support across all related workspaces",
  Members: 'Members',
  'Control Centre': 'Control Centre',
  'Submissions made': 'Submissions made',
  'Total number of submissions made during the selected time period': 'Total number of submissions made during the selected time period',
  'Decision split': 'Decision split',
  'Breakdown of decisions over the selected period': 'Breakdown of decisions over the selected period',
  'Good delivery': 'Good delivery',
  'Improvable delivery': 'Improvable delivery',
  'Bad delivery': 'Bad delivery',
};

export default aeJSON;
